export const SUBMITTED = 'submitted';
export const OPEN = 'open';
export const IN_PROGRESS = 'in_progress';
export const ACCEPTED = 'accepted';
export const COMPLETED = 'completed';
export const PARTIALLY_COMPLETED = 'partially_completed';
export const DECLINED = 'declined';
export const CANCELLED = 'cancelled';
export const CLOSED = 'closed';
export const APPROVED = 'approved';
export const PENDING_CUSTOMER_APPROVAL = 'pending_customer_approval';
export const CUSTOMER_APPROVAL_REQUIRED = 'customer_approval_required';
export const CUSTOMER_APPROVAL_RECEIVED = 'customer_approval_received';

export const AWAITING_DC_APPROVAL = 'awaiting_dc_approval';
export const OPERATIONS = 'operations';
export const FACILITIES = 'facilities';
export const ENABLEMENT = 'enablement';

export const SECURITY_IN_PROGRESS = 'security_in_progress';
export const SECURITY_COMPLETE = 'security_complete';
export const PENDING = 'pending';
export const CURRENTLY_ON_SITE = 'currently_on_site';

export const CHECKED_IN = 'checked_in';
export const CHECKED_OUT = 'checked_out';
export const UNDER_INVESTIGATION = 'under_investigation';

export const INCIDENT_DETECTED = 'incident_detected';
export const RESTORED = 'restored';
export const RESOLVED = 'resolved';
export const EXTERNAL = 'external';
export const INTERNAL = 'internal';

export const AUDIT_HISTORY_ATTRIBUTES = {
  access_list_site_visitors: 'Access List Site Visitors',
  access_reasons: 'Access Reason',
  additional_site_visitors: 'Additional Site Visitors',
  access_list_non_aal_site_visitors: 'Non AAL Site Visitors',
  access_list_non_aal_site_engineers: 'Non AAL Site Engineers',
  change_request_number: 'Change Request Number',
  customer: 'Customer',
  datacentre: 'Datacentre',
  datacentre_access_zones: 'Additional Access Zones',
  description: 'Description',
  devices: 'Devices',
  from_date: 'From Date',
  notes: 'Notes',
  rack_access_zone_ids: 'Rack Access Zones',
  racks: 'Racks',
  reason_for_access: 'Reason For Access',
  reason_for_cancel: 'Reason For Cancel',
  reason_for_decline: 'Reason For Decline',
  reason_for_partially_completed: 'Reason For Partially Completed',
  security_notes: 'Security Notes',
  security_status: 'Security Status',
  status: 'Status',
  Status: 'Status',
  title: 'Title',
  to_date: 'To Date',
  risk_assessment: 'Risk Assessment Status',
  customer_approval: 'Customer Approval Status',
  internal_task_selected_approver: 'Internal Approver',
  risk: 'Risk',
  approver_email: 'Approver Email Details',
  datacentre_to_perform: 'Datacentre To Perform',
  access_request_number: 'Access Request Number',
  access_request_created_by: 'Access Request Created By',
  duration: 'Duration',
  internal_comments: 'Internal Comments',
  scheduled_date: 'Scheduled Date',
  end_date: 'End Date',
  internal_group: 'Internal Group',
  additional_engineers: 'Additional Engineers',
  access_list_site_engineers: 'Access List Site Engineers',
  power_check_attachment: 'Power Check Attachment',
  post_change_audit_attachment: 'Post Change Audit Attachment',
  post_change_audit_image: 'Post Change Audit Image',
  power_check_calculation_table: 'Power Check Calculation Table',
  power_check: 'Power Check Status',
  post_change_audit: 'Post Change Audit Status',
  manual_power_check: 'Manual Power Check Status',
  change_request_actions: 'Change Request Actions',
  billing_code: 'Billing Code',
  estimated_date: 'Estimated Date',
  billing_cost: 'Billable Amount',
  service_request_actions: 'Service Request Actions',
  internal_assignee_name: 'Ticket Assignee Name',
  internal_assignee_email: 'Ticket Assignee Email',
  first_approver: 'Approver Email',
  risk_comment: 'Risk Comments',
  billing_details: 'Billing Reference',
  service_request_attachment: 'Service Request Attachment',
  change_request_attachment: 'Change Request Attachment',
  comments: 'Comments',
  consumables_supplied: 'Consumables Supplied',
  reason_for_late_check_in: 'Reason for Late Check In',
  peer_reviewer_id: 'Power Check Peer Reviewer',
  peer_reviewer_name: 'Power Check Peer Reviewer Name',
  peer_reviewer_email: 'Power Check Peer Reviewer Email',
  second_approver: 'Second Approver Email',
  additional_approver_email: 'Additional Approver Email',
  ignore_image: 'Rack Image Restricted',
  site_visitors_notified: 'Notify all site visitors',
};

export const AUDIT_HISTORY_INCIDENT_ATTRIBUTES = {
  additional_customers: 'Additional Customers',
  briefing_url: 'Breifing URL',
  bu_owner: 'BU Owner',
  category: 'Category',
  datacentre_id: 'Datacentre',
  description: 'Description',
  detection_date: 'Detection Date',
  estimated_date: 'Estimated Date',
  incident_action: 'Incident Action',
  incident_updates: 'Incident Updates',
  priority: 'Priority',
  reason_for_action: 'Incident Action Comments',
  resolution_plan: 'Resolution Plan',
  restoration_description: 'Restoration Description',
  resolved_date: 'Resolved Date',
  status: 'Status',
  title: 'Email Content',
  incident_request_attachment: 'Incident Request Attachment',
  include_ddc: 'Notify Datacom Data Centres Staff',
  automatic_updates: 'Automatic Update Notification',
  update_time: 'Incident Automatic Update Options',
  updates: 'Impact Type Data Centre',
  impact: 'Impact Type',
};

export const SERVICE_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [ACCEPTED]: 'Accepted',
  [PARTIALLY_COMPLETED]: 'Partially Completed',
  [COMPLETED]: 'Completed',
  [DECLINED]: 'Declined',
  [CANCELLED]: 'Cancelled',
  [CLOSED]: 'Closed',
};

export const NEW_SERVICE_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [ACCEPTED]: 'Accepted',
};

export const CHANGE_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
  [ACCEPTED]: 'Accepted',
  [COMPLETED]: 'Completed',
  [PARTIALLY_COMPLETED]: 'Partially Completed',
  [DECLINED]: 'Declined',
  [CANCELLED]: 'Cancelled',
  [CLOSED]: 'Closed',
};

export const INTERNAL_TASK_STATUSES = {
  pending: 'Pending',
  completed: 'Completed',
  failed: 'Failed',
};

export const POWER_CHECK_STATUSES = {
  pending: 'Pending',
  passed: 'Passed',
  failed: 'Failed',
};

export const POWER_CHECK_MANUAL_STATUSES = {
  notset: 'Not Set',
  pending: 'Pending',
  passed: 'Passed',
  failed: 'Failed',
  not_applicable: 'Exempted',
};

export const NEW_CHANGE_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
};

export const NEW_CHANGE_REQUEST_CREATE_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
};

export const INCIDENT_REQUEST_STATUSES = {
  [INCIDENT_DETECTED]: 'Incident Detected',
  [IN_PROGRESS]: 'In Progress',
  [CLOSED]: 'Closed',
  [RESTORED]: 'Restored',
  [RESOLVED]: 'Resolved',
};

export const NEW_INCIDENT_REQUEST_STATUSES = {
  [INCIDENT_DETECTED]: 'Incident Detected',
  [IN_PROGRESS]: 'In Progress',
};

export const ACCESS_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [ACCEPTED]: 'Accepted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [CLOSED]: 'Closed',
  [DECLINED]: 'Declined',
  [CANCELLED]: 'Cancelled',
};

export const AUDIT_HISTORY_ACCESS_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [ACCEPTED]: 'Accepted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [CLOSED]: 'Closed',
  [DECLINED]: 'Declined',
  [CANCELLED]: 'Cancelled',
};

export const ACCESS_REQUEST_SECURITY_STATUSES = {
  [PENDING]: 'Visit Pending',
  [CURRENTLY_ON_SITE]: 'Currently On Site',
  [SECURITY_COMPLETE]: 'Visit Complete',
};
export const ACCESS_REQUEST_INIT_STATUSES = {
  [PENDING]: 'Pending',
};
export const ACCESS_REQUEST_PENDING_STATUSES = {
  [PENDING]: 'Pending',
  [CURRENTLY_ON_SITE]: 'Currently On Site',
};
export const ACCESS_REQUEST_ON_SITE_STATUSES = {
  [CURRENTLY_ON_SITE]: 'Currently On Site',
  [SECURITY_COMPLETE]: 'Complete',
};
export const ACCESS_REQUEST_COMPLETE_STATUSES = {
  [SECURITY_COMPLETE]: 'Complete',
};

export const NEW_ACCESS_REQUEST_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [ACCEPTED]: 'Accepted',
};

export const NEW_CREATE_STATUSES = {
  [SUBMITTED]: 'Submitted',
  [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
  [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
  [ACCEPTED]: 'Accepted',
};

export const MAINTENANCE_STATUSES = {
  completed: 'Completed',
  scheduled: 'Scheduled',
};

// access reason options
export const ACCESS_REASON_STATUSES = {
  rack_access: 'Rack Access',
  device_install: 'Device Install',
  device_removal: 'Device Removal',
  tour: 'Tour',
  build_room: 'Build Room',
  induction: 'Induction',
  contractor_visit: 'Contractor Visit',
  other: 'Other',
};

// BU owner options
export const BU_OWNER_OPTIONS = {
  facilities: 'Facilities',
  operations: 'Operations',
  enablement: 'Enablement',
  auditing_compliance: 'Auditing/Compliance',
  health_and_safety: 'Health and safety',
  other: 'Other',
};

// Approver options
export const APPROVER_OPTIONS = {
  primary_approvers: 'Primary Approvers',
  all_approvers: 'All Approvers',
  select_approver: 'Select Approver',
};

export const APPROVER_OPTIONS_TOOLTIPS = {
  primary_approvers: 'Approver(s) listed on the AAL who are also a primary contact.',
  all_approvers: 'All Approver(s) listed on the AAL.',
  select_approver: 'One specific Approver listed on the AAL.',
};

// Category options
export const CATEGORY_OPTIONS = {
  safety: 'Safety',
  security: 'Security',
  network: 'Network',
  building: 'Building',
  power: 'Power',
  customer: 'Customer',
  other: 'Other',
};

export const INCIDENT_ACTIONS = {
  incident_under_investigation: 'Incident under Investigation',
  technician_coming_to_site: 'Technician coming to site',
  troubleshooting_issue: 'Troubleshooting issue',
  restoration_in_progress: 'Restoration in progress',
  services_restored: 'Services restored',
  incident_resolved: 'Incident resolved',
  incident_downgraded: 'Incident downgraded',
  other: 'Other',
};

export const INCIDENT_IMPACT_TYPES = {
  datacentre: 'Data Centre',
  data_floor: 'Data Floor',
  power_module: 'Power Module',
  rack: 'Rack',
  asset: 'Asset',
  location: 'Location',
};

export const CONTACT_TYPES = {
  approver: 'Approver',
  billing: 'Commercial Contact',
  invoicing_contact: 'Invoicing Contact',
  is_primary: 'Primary Contact',
  maintenance: 'Maintenance',
  reporting: 'Reporting',
  site_access: 'Site Access',
  tape_management: 'Tape Management',
};

export const NOTIFICATION_FILTER_TYPES = {
  access_request: 'Access Request',
  service_request: 'Service Request',
  change_request: 'Change Request',
  maintenance: 'Maintenance',
  manual: 'Manual',
  incident_request: 'Incident',
};

export const NOTIFICATION_TYPES = {
  datacentre: 'Data Centre',
  customer: 'Customer',
  data_floor: 'Data Floor',
  power_module: 'Power Module',
  rack: 'Rack',
  asset: 'Asset',
  location: 'Location',
};

export const DOCUMENT_TYPE = {
  monthly_report: 'Monthly Report',
  newsletter: 'Newsletter',
  policy: 'Policy',
};

export const KEY_REQUEST_STATUSES = {
  [CHECKED_IN]: 'Checked In',
  [CHECKED_OUT]: 'Checked Out',
  [UNDER_INVESTIGATION]: 'Under Investigation',
};

export const KEY_REQUEST_CO_STATUSES = {
  [CHECKED_IN]: 'Checked In',
  [UNDER_INVESTIGATION]: 'Under Investigation',
};

export const NEW_KEY_REQUEST_STATUSES = {
  [CHECKED_OUT]: 'Checked Out',
};

export const INTERNAL_GROUPS = {
  [ENABLEMENT]: 'Enablement',
  [FACILITIES]: 'Facilities',
  [OPERATIONS]: 'Operations',
};

export const CUSTOMER_DB_TEST = 'https://dc-custdb-sys.datacomdev.co.nz/Administration';
export const CUSTOMER_DB_UAT = 'https://dc-custdb-uat.datacomdev.co.nz/Administration';
export const CUSTOMER_DB_PRODUCTION =
  'https://customerdatabase.datacentres.datacom.net.nz/Administration';

export const DATE_FORMAT = 'll';
export const DATE_TIME_FORMAT = 'llll';
export const DATE_TIME_DASHBOARD_FORMAT = 'ddd, D MMM, YYYY h:mm A';
export const DATE_TIME_DRAWER_FORMAT = 'DD/MM/YYYY h:mm a';

export const NOTES_MAX_LENGTH = 4000;
export const NOTES_MAX_CHARACTER = 1000;
export const EMAIL_NOTICE_MAX_CHARACTERS = 1000;

export const ALL_OR_NO_SELECTION = [];

export const ACCESS_REQUEST_PRIORITY = ['low', 'normal', 'high', 'critical'];

export const INCIDENT_REQUEST_PRIORITY = ['critical', 'high', 'medium', 'low', 'informational'];

export const INTERNAL_TASK_RISK = ['low', 'medium', 'high'];

export const INCIDENT_TICKET_TYPE = ['internal', 'external'];

export const CHANGE_ACTION_GRID_TYPE = [
  {
    label: 'Device',
    options: [
      { label: 'Install Device', value: 'install_device' },
      { label: 'Remove', value: 'remove' },
      { label: 'Add/Remove Child', value: 'add_remove_child' },
      { label: 'Relocate', value: 'relocate' },
      { label: 'Replace New', value: 'replace_new' },
      { label: 'Replace Identical', value: 'replace_identical' },
      { label: 'Remove and Destroy', value: 'remove_and_destroy' },
    ],
  },
  {
    label: 'Rack',
    options: [
      { label: 'Deploy Rack', value: 'deploy_rack' },
      { label: 'Decommission Rack', value: 'decom_rack' },
    ],
  },
  { label: 'Other', options: [{ label: 'Other', value: 'other' }] },
];

export const EXTERNAL_CHANGE_ACTION_GRID_TYPE = [
  {
    label: 'Device',
    options: [
      { label: 'Install Device', value: 'install_device' },
      { label: 'Remove', value: 'remove' },
      { label: 'Add/Remove Child', value: 'add_remove_child' },
      { label: 'Relocate', value: 'relocate' },
      { label: 'Replace New', value: 'replace_new' },
      { label: 'Replace Identical', value: 'replace_identical' },
      { label: 'Remove and Destroy', value: 'remove_and_destroy' },
    ],
  },
  { label: 'Other', options: [{ label: 'Other', value: 'other' }] },
];

export const POWER_TYPE = ['single_phase', 'two_x_single_phase', 'three_phase', 'other'];

export const LOCK_TYPE = [
  'none',
  'master',
  'slave',
  'single',
  'shared',
  'electronic_single',
  'manual',
  'other',
];

export const RACK_HEIGHT = ['52U', '48U', 'half_rack', 'quarter_rack', 'other'];

export const WIDTH_TYPE = ['standard_(600mm)', 'oversized'];

export const SERVICE_ACTION_TYPE = [
  'cross_connection',
  'internal_patching',
  'install_device',
  'remove_device',
  'replace_device',
  'relocate_device',
  'destroy_device',
  'load_tape',
  'unload_tape',
  'check_in_tape',
  'check_out_tape',
  'tape_movement_other',
  'cable_tracing',
  'device_inspection',
  'restart_device',
  'device_other',
  'install_device_component',
  'remove_device_component',
  'replace_device_component',
  'destroy_device_component',
  'device_component_other',
  'rack_inspection',
  'rack_audit',
  'rack_escort',
  'other',
];
export const ACCESS_CONTACT_MOJ = 'Contact(s) are missing valid MOJ';

export const INTERNAL_GROUP = ['enablement', 'facilities', 'operations'];

export const SERVICE_INTERNAL_GROUP = ['operations', 'enablement', 'facilities'];

export const RACK_FACE = ['front', 'rear'];

export const INCIDENT_TICKET_TYPES = {
  internal: 'Internal',
  external: 'External',
};

export const SERVICE_ACTION_TYPES = {
  cross_connection: 'Cross Connection - Change Request',
  internal_patching: 'Internal Patching',
  install_device: 'Install Device',
  remove_device: 'Remove Device',
  replace_device: 'Replace Device',
  relocate_device: 'Relocate Device',
  destroy_device: 'Destroy Device',
  load_tape: 'Load Tape',
  unload_tape: 'Unload Tape',
  check_in_tape: 'Check-in Tape',
  check_out_tape: 'Check-out Tape',
  tape_movement_other: 'Tape Movement - Other',
  cable_tracing: 'Cable Tracing',
  device_inspection: 'Device Inspection',
  restart_device: 'Restart Device',
  shipping: 'Shipping',
  device_other: 'Device - Other',
  install_device_component: 'Install Device Component',
  remove_device_component: 'Remove Device Component',
  replace_device_component: 'Replace Device Component',
  destroy_device_component: 'Destroy Device Component',
  device_component_other: 'Device Component - Other',
  rack_inspection: 'Rack Inspection',
  rack_audit: 'Rack Audit',
  rack_escort: 'Rack Escort',
  other: 'Other',
  telco: 'Telco Connection',
  aerial: 'Aerial Connection',
  structure: 'Structured Connection',
  remove_cross_connection: 'Remove Cross Connection - Change Request',
  remove_internal_patching: 'Remove Internal Patching',
  remove_telco: 'Remove Telco Connection',
  remove_aerial: 'Remove Aerial Connection',
  remove_structure: 'Remove Structured Connection',
};

export const SERVICE_ACTION_GRID_TYPE = [
  {
    label: 'New Cabling',
    options: [
      { label: 'Internal Patching', value: 'internal_patching' },
      { label: 'Telco', value: 'telco' },
      { label: 'Aerial', value: 'aerial' },
      { label: 'Structured', value: 'structure' },
      { label: 'Cross Connection', value: 'cross_connection' },
    ],
  },
  {
    label: 'Cable Removal',
    options: [
      { label: 'Internal Patching', value: 'remove_internal_patching' },
      { label: 'Telco', value: 'remove_telco' },
      { label: 'Aerial', value: 'remove_aerial' },
      { label: 'Structured', value: 'remove_structure' },
      { label: 'Cross Connection', value: 'remove_cross_connection' },
    ],
  },
  {
    label: 'Devices',
    options: [
      { label: 'Install', value: 'install_device' },
      { label: 'Remove', value: 'remove_device' },
      { label: 'Relocate', value: 'relocate_device' },
      { label: 'Replace', value: 'replace_device' },
      { label: 'Destroy Device', value: 'destroy_device' },
      { label: 'Other', value: 'device_other' },
    ],
  },
  {
    label: 'Device Component',
    options: [
      { label: 'Install', value: 'install_device_component' },
      { label: 'Remove', value: 'remove_device_component' },
      { label: 'Replace', value: 'replace_device_component' },
      { label: 'Destroy Device Component', value: 'destroy_device_component' },
      { label: 'Other', value: 'device_component_other' },
    ],
  },
  {
    label: 'Tapes',
    options: [
      { label: 'Check in', value: 'check_in_tape' },
      { label: 'Check out', value: 'check_out_tape' },
      { label: 'Load', value: 'load_tape' },
      { label: 'Unload', value: 'unload_tape' },
      { label: 'Other', value: 'tape_movement_other' },
    ],
  },
  {
    label: 'Services',
    options: [
      { label: 'Cable Tracing', value: 'cable_tracing' },
      { label: 'Device Inspection', value: 'device_inspection' },
      { label: 'Rack Audit', value: 'rack_audit' },
      { label: 'Rack Escort', value: 'rack_escort' },
      { label: 'Rack Inspection', value: 'rack_inspection' },
      { label: 'Restart Device', value: 'restart_device' },
      { label: 'Shipping', value: 'shipping' },
    ],
  },
];

export const EXTERNAL_SERVICE_ACTION_GRID_TYPE = [
  {
    label: 'New Cabling',
    options: [
      { label: 'Internal Patching', value: 'internal_patching' },
      { label: 'Telco', value: 'telco' },
      { label: 'Structured', value: 'structure' },
      { label: 'Cross Connection', value: 'cross_connection' },
    ],
  },
  {
    label: 'Cable Removal',
    options: [
      { label: 'Internal Patching', value: 'remove_internal_patching' },
      { label: 'Telco', value: 'remove_telco' },
      { label: 'Structured', value: 'remove_structure' },
      { label: 'Cross Connection', value: 'remove_cross_connection' },
    ],
  },
  {
    label: 'Devices',
    options: [
      { label: 'Install', value: 'install_device' },
      { label: 'Remove', value: 'remove_device' },
      { label: 'Relocate', value: 'relocate_device' },
      { label: 'Replace', value: 'replace_device' },
      { label: 'Destroy Device', value: 'destroy_device' },
      { label: 'Other', value: 'device_other' },
    ],
  },
  {
    label: 'Device Component',
    options: [
      { label: 'Install', value: 'install_device_component' },
      { label: 'Remove', value: 'remove_device_component' },
      { label: 'Replace', value: 'replace_device_component' },
      { label: 'Destroy Device Component', value: 'destroy_device_component' },
      { label: 'Other', value: 'device_component_other' },
    ],
  },
  {
    label: 'Tapes',
    options: [
      { label: 'Check in', value: 'check_in_tape' },
      { label: 'Check out', value: 'check_out_tape' },
      { label: 'Load', value: 'load_tape' },
      { label: 'Unload', value: 'unload_tape' },
      { label: 'Other', value: 'tape_movement_other' },
    ],
  },
  {
    label: 'Services',
    options: [
      { label: 'Cable Tracing', value: 'cable_tracing' },
      { label: 'Device Inspection', value: 'device_inspection' },
      { label: 'Rack Audit', value: 'rack_audit' },
      { label: 'Rack Escort', value: 'rack_escort' },
      { label: 'Rack Inspection', value: 'rack_inspection' },
      { label: 'Restart Device', value: 'restart_device' },
      { label: 'Shipping', value: 'shipping' },
    ],
  },
];

export const SERVICE_ACTION_CATEGORY = {
  cabling: 'Cabling',
  devices: 'Devices',
  device_components: 'Device Components',
  tapes: 'Tapes',
  services: 'Services',
  cabling_change_request: 'Cabling Change Request',
  other: 'Other',
};

export const CABLE_TYPES = {
  multi_mode_fibre: 'Multi-Mode Fibre(Simplex)',
  multi_mode_fibre_simplex: 'Multi-Mode Fibre(Simplex)',
  multi_mode_fibre_duplex: 'Multi-Mode Fibre(Duplex)',
  single_mode_fibre_simplex: 'Single-Mode Fibre (Simplex)',
  single_mode_fibre_duplex: 'Single-Mode Fibre (Duplex)',
  cat5e: 'CAT5e',
  cat6: 'CAT6',
  coaxial: 'Coaxial',
  other: 'Other',
};

export const CABLE_ACTIONS_DROPDOWN_FIELDS = {
  cable_type: {
    multi_mode_fibre: 'Multi-Mode Fibre(Simplex)',
    multi_mode_fibre_simplex: 'Multi-Mode Fibre(Simplex)',
    multi_mode_fibre_duplex: 'Multi-Mode Fibre(Duplex)',
    single_mode_fibre_simplex: 'Single-Mode Fibre (Simplex)',
    single_mode_fibre_duplex: 'Single-Mode Fibre (Duplex)',
    cat5e: 'CAT5e',
    cat6: 'CAT6',
    coaxial: 'Coaxial',
    other: 'Other',
  },
  patching: {
    none: 'None',
    customer_a: 'Customer A',
    customer_b: 'Customer B',
    side_a: 'Side A',
    side_b: 'Side B',
    telco_side: 'Telco Side',
    customer_side: 'Customer Side',
    both: 'Both',
  },
  internal_patching_type: {
    patch: 'Patch',
    remove: 'Remove',
    single_sided_patch: 'Single Sided Patch',
    single_sided_remove: 'Single Sided Remove',
  },
  antenna_capabilities: {
    transmitting: 'Transmitting',
    receiving: 'Receiving',
    transmitting_and_receiving: 'Transmitting & Receiving',
  },
  face: {
    front: 'Front',
    rear: 'Rear',
  },
  to_face: {
    front: 'Front',
    rear: 'Rear',
  },
};

export const INTERNAL_PATCHING_TYPES = {
  patch: 'Patch',
  remove: 'Remove',
  single_sided_patch: 'Single Sided Patch',
  single_sided_remove: 'Single Sided Remove',
};

export const ACTION_TYPES = {
  remove: 'Remove Device',
  relocate: 'Relocate Device',
  relocate_install: 'Relocate Device',
  relocate_remove: 'Relocate Device',
  replace_new: 'Replace Device - New',
  add_remove_child: 'Add/Remove Child',
  replace_identical: 'Replace Device - Identical',
  install_device: 'Install Device',
  remove_and_destroy: 'Remove and Destroy',
  other: 'Other',
  deploy_rack: 'Deploy Rack',
  decom_rack: 'Decom Rack',
};

export const POWER_TYPES = {
  single_phase: 'Single Phase',
  two_x_single_phase: '2X Single Phase',
  three_phase: 'Three Phase',
};

export const LOCK_TYPES = {
  none: 'None',
  master: 'Master',
  slave: 'Slave',
  single: 'Single',
  shared: 'Shared',
  electronic_single: 'Electronic Single',
  manual: 'Manual',
};

export const RACK_HEIGHTS = {
  half_rack: 'Half Rack',
  quarter_rack: 'Quarter Rack',
  other: 'Other',
};

export const ESCORT_REQUIRED_STATUS = ['yes', 'no'];
export const TICKET_APPROVAL_STATUS = ['approved', 'not_approved'];

export const RACKED_UNRACKED = ['racked', 'unracked'];

export const ACCESS = 'ACCESS';
export const ACCESS_EXTERNAL = 'ACCESS_EXTERNAL';
export const ACCESS_SECURITY = 'ACCESS_SECURITY';
export const CHANGE = 'CHANGE';
export const CHANGE_EXTERNAL = 'CHANGE_EXTERNAL';
export const ADDITIONAL = 'ADDITIONAL';
export const NEW_ACTION = 'NEW_ACTION';
export const ADDITIONAL_ENGINEER = 'ADDITIONAL_ENGINEER';
export const ADDITIONAL_REQUESTER = 'ADDITIONAL_REQUESTER';
export const ADDITIONAL_CUSTOMER = 'ADDITIONAL_CUSTOMER';
export const NEW_UPDATE = 'NEW_UPDATE';

export const SERVICE = 'SERVICE';
export const SERVICE_EXTERNAL = 'SERVICE_EXTERNAL';

export const SIGN_OUT = 'signOut';
export const SIGN_IN = 'signIn';

export const SECURITY = 'Security';
export const OPERATIONAL = 'Operational';
export const CUSTOMER_TEAM = 'Customer_Team';

export const SECURITY_TEAM_USER = 'SECURITY_TEAM_USER';
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const SUPERVISOR = 'SUPERVISOR';
export const VIEW_ONLY = 'VIEW_ONLY';

export const KEY = 'KEY';

// Contact / AAL wording and limits shared by Contact Management, the AAL and the profile page
export const MOJ_SUPPLIER_ID_HELP =
  'Required for unescorted access in New Zealand. Provide the supplier request ID associated with a Ministry of Justice (MOJ) Criminal Background Check (CBC) completed within the last two years.';
export const MOJ_REQUEST_DATE_HELP =
  'The date the Criminal Background Check (CBC) was requested from the Ministry of Justice. It must be within the last two years; the expiry date is calculated from it.';
export const CONTACT_NAME_MAX = 255;
export const CONTACT_EMAIL_MAX = 100;

export const API_NAME = process.env.REACT_APP_AWS_API_NAME;

export const maxCharacterLength = (length) => `Max length of ${length} characters reached`;
export const fieldRequired = (field) => `${field} is required`;
export const URLformatValidation = (url) => `${url} is invalid`;
export const invalidBeforeCurrentDateTime = (fieldName, dateTime) =>
  `${fieldName} date time cannot before or be the same as ${dateTime}`;

export const TO_DATE_AFTER_FROM_DATE = 'End date time must be after Scheduled the date time';
export const FROM_DATE_BEFORE_TO_DATE = 'Schedule date time must be before the End date time';
export const FROM_DATE_IN_THE_PAST = 'Requested date time must be after current date time';
export const SCHEDULED_DATE_IN_THE_PAST = 'Scheduled date time must be after current date time';
export const END_DATE_IN_THE_PAST = 'End date time must be after current date time';
export const CHANGE_SCHEDULED_DATE_TOO_OLD =
  'Scheduled date time cannot be more than 9 days in the past';
export const CHANGE_END_DATE_TOO_OLD = 'End date time cannot be more than 9 days in the past';
export const STATUS_INVALID = 'Request status is invalid';
export const REQUESTER_EMAIL_INVALID = 'Invalid email format';
export const RACKS_REQUIRED = 'Select at least one rack';
export const ACCESS_ZONES_REQUIRED = 'Select at least one access zone for each rack';
export const ADDITIONAL_CONTACT_NOT_REQUIRED = 'Request has non access list contacts';
export const CUSTOMER_APPROVAL_REQUIRED_FOR_NON_AAL_CONTACTS =
  'Customer Approval is required when the request has non Access List or Site Access Contacts.';
export const ACCESS_REASON_REQUIRED = 'Select one or more access reasons';
export const ACCESS_REASON_OTHER = 'Other Access Reason chosen - Manually validate';
export const ACCESS_ZONES_CONTRACTOR_VISIT_REQUIRED =
  'Contractor Visit requires at least one Additional Access Zone.';
export const ACCESS_REASON_DECLINED = 'Access Request declined - Reason needed';
export const ACCESS_REASON_CANCELLED = 'Access Request cancelled - Reason needed';
export const KEY_REQUIRED =
  'Please select at least one key from Available Keys - Key(s) being Checked Out or Under Investigation by another ticket will not be available.';
export const REQUESTER_REQUIRED = 'Select or Add at least one requester';
export const CHANGE_REQUEST_NUMBER_REQUIRED = 'Change Request Number Required';
export const CHANGE_REQUEST_NUMBER_MISSING = 'Change Request Number is Missing';
export const RACKS_INVALID = 'One or more of your racks has an invalid date';
export const PRIORITY_INVALID = 'Priority is required';
export const CONTACT_REQUIRED =
  'Must have at least one Access contact or Additional contact or Non AAL contact';
export const ENGINEER_REQUIRED =
  'Must have at least one Access engineer or Additional engineer or Non AAL engineer';
export const ACCESS_CONTACT_REQUIRED = 'Must have at least one Access contact';
export const KEYS_REQUIRED = 'Must have at least one Key';
export const REQUESTERS_REQUIRED = 'Must have at least one Requester';
export const ESCORT_NAME_REQUIRED =
  'Must have Escort Name if Escort Required is Yes for Additional contact';
export const ACCESS_CONTACT_SITE_ACCESS = 'Contact(s) do not have the attribute site access';
export const ACCESS_CONTACT_INDUCTION = 'Contact(s) are missing valid induction';
export const COMMENTS_REQUIRED = 'Requester Email is required';
export const EQUINIX_NUMBER_REQUIRED = 'Equinix Access Number is required';
export const AIRTRUNK_NUMBER_REQUIRED = 'AirTrunk Access Number is required';
export const HIGHBROOK_NUMBER_REQUIRED = 'Highbrook Access Number is required';

export const ACCESS_REQUEST_SECURITY_FORM_PERMISSIONS = {
  [PENDING]: {
    permittedStatuses: [CURRENTLY_ON_SITE],
    unchangeableFields: [],
  },
  [CURRENTLY_ON_SITE]: {
    permittedStatuses: [SECURITY_COMPLETE],
    unchangeableFields: [],
  },
  [SECURITY_COMPLETE]: {
    permittedStatuses: [],
    unchangeableFields: ['security_status', 'security_notes'],
  },
};

export const ACCESS_REQUEST_FORM_PERMISSIONS = {
  submitted: {
    permittedStatuses: [
      CUSTOMER_APPROVAL_REQUIRED,
      CUSTOMER_APPROVAL_RECEIVED,
      ACCEPTED,
      CANCELLED,
      DECLINED,
    ],
    permittedStatusFlow: {
      [SUBMITTED]: 'Submitted',
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  customer_approval_required: {
    permittedStatuses: [CANCELLED, ACCEPTED, DECLINED, CUSTOMER_APPROVAL_RECEIVED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  customer_approval_received: {
    permittedStatuses: [CANCELLED, ACCEPTED, DECLINED, CUSTOMER_APPROVAL_REQUIRED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  accepted: {
    permittedStatuses: [
      CUSTOMER_APPROVAL_REQUIRED,
      CUSTOMER_APPROVAL_RECEIVED,
      CANCELLED,
      DECLINED,
      CLOSED,
    ],
    permittedStatusFlow: {
      [ACCEPTED]: 'Accepted',
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [CLOSED]: 'Closed',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  declined: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [DECLINED]: 'Declined',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'reason_for_access',
      'access_reasons', // Access Reason Options
      'from_date', // Scheduled Date/Time
      'to_date', // End Date/Time
      'racks',
      'change_request_number',
      'access_list_site_visitors', // Access Contacts
      'additional_site_visitors', // Additional Contacts
      'airtrunk_access_number',
      'equinix_access_number',
      'highbrook_access_number',
    ],
  },
  cancelled: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [CANCELLED]: 'Cancelled',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'reason_for_access',
      'access_reasons',
      'from_date', // Scheduled Date/Time
      'to_date', // End Date/Time
      'racks',
      'change_request_number',
      'access_list_site_visitors', // Access Contacts
      'additional_site_visitors', // Additional Contacts
      'airtrunk_access_number',
      'no_racks_override',
      'site_visitors_notified',
      'equinix_access_number',
      'highbrook_access_number',
      'custom_email_header_enabled',
      'email_notice',
    ],
  },
  closed: {
    permittedStatuses: [],
    permittedStatusFlow: {
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'status',
      'customer',
      'datacentre',
      'requester',
      'reason_for_access',
      'access_reasons',
      'from_date', // Scheduled Date/Time
      'to_date', // End Date/Time
      'racks',
      'change_request_number',
      'access_list_site_visitors', // Access Contacts
      'additional_site_visitors', // Additional Contacts
      'no_racks_override',
      'site_visitors_notified',
      'custom_email_header_enabled',
      'email_notice',
    ],
  },
};

export const KEY_REQUEST_FORM_PERMISSIONS = {
  checked_in: {
    permittedStatuses: [],
    unchangeableFields: ['customer', 'datacentre', 'requester', 'datacentre_key_lockers', 'status'],
  },
  under_investigation: {
    permittedStatuses: [CHECKED_IN],
    unchangeableFields: ['customer', 'datacentre', 'requester', 'datacentre_key_lockers'],
  },
  checked_out: {
    permittedStatuses: [CHECKED_IN, UNDER_INVESTIGATION],
    unchangeableFields: ['customer', 'datacentre', 'requester', 'datacentre_key_lockers'],
  },
};

export const SERVICE_REQUEST_FORM_PERMISSIONS = {
  [SUBMITTED]: {
    permittedStatuses: [
      CANCELLED,
      DECLINED,
      CUSTOMER_APPROVAL_REQUIRED,
      ACCEPTED,
      CUSTOMER_APPROVAL_RECEIVED,
    ],
    permittedStatusFlow: {
      [SUBMITTED]: 'Submitted',
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  [CUSTOMER_APPROVAL_REQUIRED]: {
    permittedStatuses: [ACCEPTED, CANCELLED, DECLINED, CUSTOMER_APPROVAL_RECEIVED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  [CUSTOMER_APPROVAL_RECEIVED]: {
    permittedStatuses: [ACCEPTED, CANCELLED, DECLINED, CUSTOMER_APPROVAL_REQUIRED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  [ACCEPTED]: {
    permittedStatuses: [
      CUSTOMER_APPROVAL_REQUIRED,
      CANCELLED,
      DECLINED,
      CUSTOMER_APPROVAL_RECEIVED,
      COMPLETED,
      PARTIALLY_COMPLETED,
    ],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [ACCEPTED]: 'Accepted',
      [PARTIALLY_COMPLETED]: 'Partially Completed',
      [COMPLETED]: 'Completed',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['customer', 'datacentre', 'requester'],
  },
  [DECLINED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [DECLINED]: 'Declined',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'title',
      'description',
      'devices',
      'from_date', // Scheduled Date/Time
      'racks',
      'change_request_number',
      'no_racks_override',
      'approver_email',
      'billing_cost',
      'billing_code',
      'end_date',
    ],
  },
  [CANCELLED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [CANCELLED]: 'Cancelled',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'title',
      'description',
      'devices',
      'from_date', // Scheduled Date/Time
      'racks',
      'change_request_number',
      'no_racks_override',
      'approver_email',
      'billing_cost',
      'billing_code',
      'end_date',
    ],
  },
  [COMPLETED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [COMPLETED]: 'Completed',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'title',
      'description',
      'devices',
      'from_date', // Scheduled Date/Time
      'racks',
      'change_request_number',
      'no_racks_override',
      'approver_email',
      'billing_code',
      'end_date',
    ],
  },
  [PARTIALLY_COMPLETED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [PARTIALLY_COMPLETED]: 'Partially Completed',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'customer',
      'datacentre',
      'requester',
      'title',
      'description',
      'devices',
      'from_date', // Scheduled Date/Time
      'racks',
      'change_request_number',
      'no_racks_override',
      'approver_email',
      'billing_code',
      'end_date',
    ],
  },
  [CLOSED]: {
    permittedStatuses: [],
    permittedStatusFlow: {
      [CLOSED]: 'Closed',
    },
    unchangeableFields: [
      'status',
      'customer',
      'datacentre',
      'requester',
      'title',
      'description',
      'devices',
      'from_date', // Scheduled Date/Time
      'racks',
      'change_request_number',
      'no_racks_override',
      'approver_email',
      'billing_code',
      'end_date',
    ],
  },
};

// Incident Update options
export const INCIDENT_UPDATE_OPTIONS = {
  fifteen: '15 Minutes',
  thirty: '30 Minutes',
  sixty: '60 Minutes',
};

export const INCIDENT_REQUEST_FORM_PERMISSIONS = {
  [INCIDENT_DETECTED]: {
    permittedStatuses: [INCIDENT_DETECTED, IN_PROGRESS],
    unchangeableFields: ['datacentre'],
  },
  [IN_PROGRESS]: {
    permittedStatuses: [RESTORED, IN_PROGRESS],
    unchangeableFields: ['datacentre'],
  },
  [RESTORED]: {
    permittedStatuses: [IN_PROGRESS, RESTORED, RESOLVED],
    unchangeableFields: ['datacentre', 'title', 'description', 'devices', 'priority'],
  },
  [RESOLVED]: {
    permittedStatuses: [CLOSED],
    unchangeableFields: ['datacentre', 'title', 'description', 'priority'],
  },
  [CLOSED]: {
    permittedStatuses: [],
    unchangeableFields: [
      'status',
      'datacentre',
      'title',
      'description',
      'priority',
      'restoration_description',
      'resolution_plan',
    ],
  },
};

export const CHANGE_REQUEST_FORM_PERMISSIONS = {
  [SUBMITTED]: {
    permittedStatuses: [
      SUBMITTED,
      AWAITING_DC_APPROVAL,
      CUSTOMER_APPROVAL_REQUIRED,
      CUSTOMER_APPROVAL_RECEIVED,
      CANCELLED,
    ],
    permittedStatusFlow: {
      [SUBMITTED]: 'Submitted',
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [CUSTOMER_APPROVAL_REQUIRED]: {
    permittedStatuses: [AWAITING_DC_APPROVAL, CANCELLED, CUSTOMER_APPROVAL_RECEIVED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [CUSTOMER_APPROVAL_RECEIVED]: {
    permittedStatuses: [AWAITING_DC_APPROVAL, CANCELLED, CUSTOMER_APPROVAL_REQUIRED],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [AWAITING_DC_APPROVAL]: {
    permittedStatuses: [
      ACCEPTED,
      DECLINED,
      CANCELLED,
      CUSTOMER_APPROVAL_REQUIRED,
      CUSTOMER_APPROVAL_RECEIVED,
    ],
    permittedStatusFlow: {
      [SUBMITTED]: 'Submitted',
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
      [ACCEPTED]: 'Accepted',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [ACCEPTED]: {
    permittedStatuses: [
      CUSTOMER_APPROVAL_REQUIRED,
      CUSTOMER_APPROVAL_RECEIVED,
      AWAITING_DC_APPROVAL,
      DECLINED,
      CANCELLED,
      COMPLETED,
      PARTIALLY_COMPLETED,
    ],
    permittedStatusFlow: {
      [CUSTOMER_APPROVAL_REQUIRED]: 'Customer Approval Required',
      [CUSTOMER_APPROVAL_RECEIVED]: 'Customer Approval Received',
      [AWAITING_DC_APPROVAL]: 'Awaiting Data Centre Approval',
      [ACCEPTED]: 'Accepted',
      [COMPLETED]: 'Completed',
      [PARTIALLY_COMPLETED]: 'Partially Completed',
      [DECLINED]: 'Declined',
      [CANCELLED]: 'Cancelled',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [COMPLETED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [COMPLETED]: 'Completed',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [PARTIALLY_COMPLETED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [PARTIALLY_COMPLETED]: 'Partially Completed',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [DECLINED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [DECLINED]: 'Declined',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [CANCELLED]: {
    permittedStatuses: [CLOSED],
    permittedStatusFlow: {
      [CANCELLED]: 'Cancelled',
      [CLOSED]: 'Closed',
    },
    unchangeableFields: ['datacentre', 'customer'],
  },
  [CLOSED]: {
    permittedStatuses: [],
    permittedStatusFlow: {
      [CLOSED]: 'Closed',
    },
    unchangeableFields: ['status', 'datacentre', 'customer'],
  },
};

export const SERVICE_MAX_ACTION_PAGES = 2;
export const SERVICE_ACTION_STEPS = ['Action Selection', 'Action Details'];
export const SERVICE_ACTIONS_GROUPING_MODEL = {
  cross_connection: [
    {
      groupId: 'Customer A',
      children: [
        { field: 'cable_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
      ],
    },
    {
      groupId: 'Customer B',
      children: [
        { field: 'customer' },
        { field: 'customer_not_listed' },
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }, { field: 'patching' }],
    },
  ],
  remove_cross_connection: [
    {
      groupId: 'Customer A',
      children: [
        { field: 'cable_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
      ],
    },
    {
      groupId: 'Customer B',
      children: [
        { field: 'customer' },
        { field: 'customer_not_listed' },
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }, { field: 'patching' }],
    },
  ],
  internal_patching: [
    {
      groupId: 'Side A',
      children: [
        { field: 'cable_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
      ],
    },
    {
      groupId: 'Side B',
      children: [
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }, { field: 'patching' }],
    },
  ],
  remove_internal_patching: [
    {
      groupId: 'Side A',
      children: [
        { field: 'cable_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
      ],
    },
    {
      groupId: 'Side B',
      children: [
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [
        { field: 'cable_label' },
        { field: 'patching' },
        { field: 'internal_patching_type' },
      ],
    },
  ],
  telco: [
    {
      groupId: 'Telco',
      children: [
        { field: 'cable_type' },
        { field: 'provider_rack' },
        { field: 'provider_switch' },
        { field: 'provider_port' },
        { field: 'rack' },
      ],
    },
    {
      groupId: 'Customer',
      children: [
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }, { field: 'patching' }],
    },
  ],
  remove_telco: [
    {
      groupId: 'Telco',
      children: [
        { field: 'cable_type' },
        { field: 'provider_rack' },
        { field: 'provider_switch' },
        { field: 'provider_port' },
        { field: 'rack' },
      ],
    },
    {
      groupId: 'Customer',
      children: [
        { field: 'to_rack' },
        { field: 'to_rack_ru' },
        { field: 'to_device_name' },
        { field: 'to_port' },
      ],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }],
    },
  ],
  aerial: [
    {
      groupId: 'Aerial',
      children: [
        { field: 'cable_type' },
        { field: 'connector_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
        { field: 'comms_platform_ru' },
        { field: 'antenna_specifications' },
        { field: 'antenna_dimensions' },
        { field: 'customer_circuit_id' },
        { field: 'antenna_capabilities' },
      ],
    },
  ],
  remove_aerial: [
    {
      groupId: 'Aerial',
      children: [
        { field: 'cable_type' },
        { field: 'connector_type' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'device_name' },
        { field: 'port' },
        { field: 'comms_platform_ru' },
        { field: 'antenna_specifications' },
        { field: 'antenna_dimensions' },
        { field: 'customer_circuit_id' },
        { field: 'antenna_capabilities' },
      ],
    },
  ],
  structure: [
    {
      groupId: 'Customer A',
      children: [{ field: 'rack' }, { field: 'rack_ru' }, { field: 'face' }],
    },
    {
      groupId: 'Customer B',
      children: [{ field: 'to_rack' }, { field: 'to_rack_ru' }, { field: 'to_face' }],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }],
    },
  ],
  remove_structure: [
    {
      groupId: 'Structure',
      children: [
        { field: 'cable_type' },
        { field: 'number_of_ports_required' },
        { field: 'rack' },
        { field: 'rack_ru' },
        { field: 'face' },
      ],
    },
    {
      groupId: 'Customer',
      children: [{ field: 'to_rack' }, { field: 'to_rack_ru' }, { field: 'to_face' }],
    },
    {
      groupId: 'Cabling Details',
      children: [{ field: 'cable_label' }],
    },
  ],
};
export const SERVICE_CABLE_ACTIONS = [
  'cross_connection',
  'internal_patching',
  'telco',
  'aerial',
  'structure',
  'remove_cross_connection',
  'remove_internal_patching',
  'remove_telco',
  'remove_aerial',
  'remove_structure',
];

export const FEEDBACK_FORM_TYPES = [
  'General Feedback',
  'Bug/Issue',
  'New Feature Request',
  'Data Issue',
  'Other',
];

export const FAQ_Categories = [
  'Most Popular',
  'General',
  'Registration & Sign In',
  'Security',
  'Access Requests',
  'Service Requests',
  'Change Requests',
  'Authorised Access Lists',
  'Notifications',
  'Technical Support',
  'Training & Feedback',
];

export const RESUBMITTED = 'resubmitted';
export const RESUBMISSION_EXEMPT_FIELDS = {
  access: [
    'change_request_number',
    'site_visitors_notified',
    'custom_email_header_enabled',
    'email_notice',
    'customer_approval',
    'approver_email',
    'request_approved',
    'approved_by',
    'approved_time',
    'internal_task_approver_options',
    'internal_task_approved_time',
    'internal_task_selected_approver',
  ],
  service: [
    'change_request_number',
    'billing_code',
    'billing_cost',
    'customer_approval',
    'approver_email',
    'request_approved',
    'approved_by',
    'approved_time',
    'internal_task_approver_options',
    'internal_task_approved_time',
    'internal_task_selected_approver',
  ],
  change: [
    'billing_details',
    'billing_code',
    'billing_cost',
    'customer_approval',
    'approver_email',
    'request_approved',
    'approved_by',
    'approved_time',
    'internal_task_approver_options',
    'internal_task_approved_time',
    'internal_task_selected_approver',
  ],
};
export const RESUBMISSION_TRIGGER_STATUSES = {
  access: [CUSTOMER_APPROVAL_REQUIRED, CUSTOMER_APPROVAL_RECEIVED, ACCEPTED],
  service: [CUSTOMER_APPROVAL_REQUIRED, CUSTOMER_APPROVAL_RECEIVED, ACCEPTED],
  change: [CUSTOMER_APPROVAL_REQUIRED, CUSTOMER_APPROVAL_RECEIVED, AWAITING_DC_APPROVAL, ACCEPTED],
};
export const REAPPROVAL_TRIGGER_STATUSES = {
  access: [ACCEPTED],
  service: [ACCEPTED],
  change: [AWAITING_DC_APPROVAL, ACCEPTED],
};
export const APPROVAL_STATUS_ORDER = {
  access: [SUBMITTED, CUSTOMER_APPROVAL_REQUIRED, CUSTOMER_APPROVAL_RECEIVED, ACCEPTED],
  service: [SUBMITTED, CUSTOMER_APPROVAL_REQUIRED, CUSTOMER_APPROVAL_RECEIVED, ACCEPTED],
  change: [
    SUBMITTED,
    CUSTOMER_APPROVAL_REQUIRED,
    CUSTOMER_APPROVAL_RECEIVED,
    AWAITING_DC_APPROVAL,
    ACCEPTED,
  ],
};
export const APPROVAL_RESET_STATUSES = [SUBMITTED, CUSTOMER_APPROVAL_REQUIRED];
export const RESUBMISSION_SUGGESTION =
  'Changes have been detected that require resubmission. Do you want to change the status to Resubmit?';
export const RESUBMISSION_CONFIRMATION =
  'Proceeding with these changes will resubmit the ticket for the Data Centres to process.';
export const RESUBMITTED_DISPLAY_STATUS = 'Resubmitted';

export const CONTACT_TOPICS = [
  'General',
  'Access Requests',
  'Smart Hands & Eyes',
  'Change Requests',
  'Billing & Reporting',
  'Portal Support',
];

export const ASSISTANCE_DETAILS_MAX_CHARACTERS = 250;
